import { ConfigProvider, DatePicker } from 'antd'
import locale from 'antd/locale/ru_RU'
import dayjs from 'dayjs'

import 'dayjs/locale/ru'

dayjs.locale('ru')

const DatePickerRu = (props) => {
    const { RangePicker } = DatePicker

    return (
        <ConfigProvider locale={locale}>
            <RangePicker {...props} />    
        </ConfigProvider>
    )
}

export default DatePickerRu
